<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  :not(.is-overlay) {
    height: 100%;
    display: flex;
    flex-direction: column;

    &.skeleton {
      @include mixins.skeleton(
        (
          background-color: colors.get(interfaceTransparentBlack_4),
          border-radius: utils.in_rem(12px),
        )
      );

      padding-bottom: utils.in_rem(9px);
    }

    // Reduce the size of the container when the filter is shown so it doesn't overflow
    &.with-filter {
      // filter button - border + padding = 36px - 2px + 12px = 46px
      height: calc(100% - utils.in_rem(46px));
    }

    .container {
      display: flex;
      flex: 1;
      overflow: hidden;

      > .inner {
        flex: 1;
        overflow: auto;

        // Keep the scrollbar right at the edge of the container
        margin-right: utils.in_rem(-12px);
      }

      &.no-company-info {
        justify-content: center;
        align-items: center;
      }

      padding: utils.in_rem(12px);
      border-radius: 16px;

      background-color: colors.get(interfaceSwGrey_4);
    }
  }
</style>

<script>
  import NoCompanyInfo from "./NoCompanyInfo.svelte";
  import { companyInsightsStore, isOverlayStore } from "./stores";

  export let showEmptyState = false;
  export let showFilter = false; // For News and Jobs

  const { meta } = companyInsightsStore;

  $: skeleton = $meta.fetching || !$meta.firstFetchDone;
</script>

<div
  class:skeleton
  class:with-filter={showFilter}
  class:is-overlay={$isOverlayStore}
>
  {#if !skeleton}
    {#if Object.keys($companyInsightsStore).length && !showEmptyState}
      <div class="container">
        <div class="inner">
          <slot />
        </div>
      </div>
    {:else}
      <div class="container no-company-info">
        <NoCompanyInfo>
          <span><slot name="noCompanyInfo" /></span>
          <span slot="sub-text"><slot name="noCompanyInfoSubtext" /></span>
        </NoCompanyInfo>
      </div>
    {/if}
  {/if}
</div>
